import { useNavigate } from 'react-router-dom';

import { useDeleteMatter } from '@/api/mutations/useDeleteMatter';
import { TypedNameDeleteDialog } from '@/new/components/dialogs/typed-name-delete-dialog';

interface DeleteMatterDialogProps {
  matterId: string;
  matterName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  redirectOnSuccess?: boolean;
}

export function DeleteMatterDialog({
  matterId,
  matterName,
  open,
  onOpenChange,
  redirectOnSuccess = false,
}: DeleteMatterDialogProps) {
  const navigate = useNavigate();
  const deleteMatter = useDeleteMatter();

  const displayName = matterName || 'Untitled Matter';

  const handleDelete = () => {
    deleteMatter.mutate(matterId, {
      onSuccess: () => {
        onOpenChange(false);
        if (redirectOnSuccess) {
          navigate('/matters');
        }
      },
    });
  };

  return (
    <TypedNameDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete Matter"
      confirmationName={displayName}
      inputPlaceholder="Type the matter name to confirm"
      confirmLabel="Delete Matter"
      isDeleting={deleteMatter.isLoading}
      onConfirm={handleDelete}
    >
      <p>
        This action cannot be undone. This will permanently delete the Matter and all its Subsets, documents, and data.
      </p>
      <p className="mb-6">
        Once you delete the Matter, it may take up to 30 minutes for the data to be completely removed.
      </p>
    </TypedNameDeleteDialog>
  );
}
